import useAccessControl from 'legacy/components/AccessControl/useAccessControl'
import { type AccessControlConfig } from 'legacy/components/AccessControl/accessControl.utils'
import { type Permission } from 'domains/reports/access-control/permissions'
import { type Flipper } from 'domains/reports/access-control/flippers'

export type DomainAccessControlConfig =
  | AccessControlConfig<Flipper, Permission>
  | AccessControlConfig<Flipper, Permission>[]

export const useDomainAccessControl = useAccessControl as any as () => (
  accessControlConfig: DomainAccessControlConfig
) => boolean
